<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext pb-50">
      <div class="container">
        <div class="area_wrap">
          <div class="text_wrap info">
            <div class="tw_detail">
              <div class="tw_item">
                <div class="tw_content">
                  <span>
                    옛, 땡큐서울이비인후과는 내분비내과(내분비대사내과) 뿐 아니라 병리과, 영상의학과를 보강하기로 하고 2022.10. 병원명을 땡큐서울의원으로 변경했습니다. 
                    2022.12. 서울 강남구 테헤란로 408 대치빌딩(누네안과병원 건물) 4,5,6층으로 확장이전했습니다. 
                  </span>
                  </div>
              </div>
              <div class="tw_item">
                <div class="tw_imgWrap">
                  <div class="tw_img first">
                    <div class="img_sub">
                      <h3> 서울 강남구 테헤란로 408 대치빌딩(누네안과병원 건물) 4,5,6층</h3>
                    </div>
                    <img src="@/assets/images/facilityInfo_0_0.jpg">
                  </div>
                  <div class="tw_img">
                    <img src="@/assets/images/facilityInfo_0_1.jpg">
                  </div>
                  <div class="tw_img">
                  </div>
                  <div class="tw_img">
                    <div class="img_sub">
                      <h3>4층 안내 </h3>
                      <div class="sub_txt">
                        <span>
                          4층에는 갑상선-내분비내과 외래센터와 병리진단검사센터가 있습니다.<br/>
                          외래센터에는 3개의 진료실과 2개의 초음파검사실이 있습니다. <br/>
                          병리진단검사센터에는 병리과(조직병리 및 세포병리, 면역병리, 동결절편 검사실)와 임상병리검사실이 있습니다.<br/>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="tw_img">
                    <div class="img_sub">
                      <h3>갑상선-내분비내과 외래센터 및 병리진단검사센터 대기실</h3>
                      <!-- <div class="sub_txt">
                        <span>세침흡인세포검사, 고주파열치료술 등 시술</span>
                      </div> -->
                    </div>
                    <img src="@/assets/images/facilityInfo_1_0.jpg">
                  </div>
                  <div class="tw_img">
                    <div class="img_sub">
                      <h3> 병리검사실 및 임상병리검사실</h3>
                      <!-- <div class="sub_txt">
                        <span>세침흡인세포검사, 고주파열치료술 등 시술</span>
                      </div> -->
                    </div>
                    <img src="@/assets/images/facilityInfo_1_3.jpg">
                  </div>
                  <div class="tw_img">
                    <div class="img_sub">
                      <h3>임상병리검사실 </h3>
                      <!-- <div class="sub_txt">
                        <span>굴곡형후두내시경, 성대미세진동검사</span>
                      </div> -->
                    </div>
                    <img src="@/assets/images/facilityInfo_1_4.jpg">
                  </div>
                  <div class="tw_img">
                    <div class="img_sub">
                      <h3>5층안내</h3>
                      <div class="sub_txt">
                        <span>
                          병원의 중심은 5층으로 접수 및 수납은 5층에서 이루어집니다. <br/>
                          5층은 갑상선-두경부외과 외래센터로,<br/>
                          이비인후과, 내분비내과 외래 진료실 6개, 초음파검사실 6개, 음성치료실 2개, 상담실이 있습니다.<br/>
                          연구개발전담부서, 행정실, 콜센터도 5층에 있습니다. 
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="tw_img">
                    <div class="img_sub">
                      <h3>갑상선-두경부외과 (이비인후과) 및 내분비내과 외래 진료실 대기실</h3>
                      <div class="sub_txt">
                      </div>
                      <img src="@/assets/images/facilityInfo_2_0.jpg">
                    </div>
                  </div>
                  <div class="tw_img">
                    <div class="img_sub">
                      <h3>접수 데스크, 진료실, 초음파검사실, 미션과 비전 보드</h3>
                      <div class="sub_txt">
                      </div>
                      <img src="@/assets/images/facilityInfo_2_1.jpg">
                    </div>
                  </div>
                  <div class="tw_img">
                    <div class="img_sub">
                      <h3>6층안내</h3>
                      
                      <div class="sub_txt">
                        <span>
                          6층에는 수술센터/입원실과 영상의학센터가 있습니다. <br/>
                          수술센터에는 2개의 수술실, 회복실이 있고, 8병실(14병상)을 운영합니다.<br/>
                          영상의학센터에는 64채널 전신CT, X-ray, 골밀도검사기가 있습니다. 
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="tw_img">
                    <div class="img_sub">
                      <h3>수술센터/입원실 입구 및 영상의학센터 접수 대기실</h3>
                    </div>
                    <img src="@/assets/images/facilityInfo_3_0.jpg">
                  </div>
                  <div class="tw_img">
                    <div class="img_sub">
                      <h3>입원실 복도</h3>
                    </div>
                    <img src="@/assets/images/facilityInfo_3_1.jpg">
                  </div>
                  <div class="tw_img">
                    <div class="img_sub">
                      <h3>수술센터 내 수술실 2실</h3>
                    </div>
                    <img src="@/assets/images/facilityInfo_3_3.jpg">
                  </div>
                  <div class="tw_img">
                    <div class="img_sub">
                      <h3>입원실 특실 (실내 화장실 유)</h3>
                    </div>
                    <img src="@/assets/images/facilityInfo_3_4.jpg">
                  </div>
                  <div class="tw_img">
                    <div class="img_sub">
                      <h3>입원실 1인실</h3>
                    </div>
                    <img src="@/assets/images/facilityInfo_3_5.jpg">
                  </div>
                  <div class="tw_img">
                    <div class="img_sub">
                      <h3>입원실 4인실</h3>
                    </div>
                    <img src="@/assets/images/facilityInfo_3_6.jpg">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
export default {
  data () {
    return {
      transDate: {
        headerName: '병원시설안내',
        prevUrl: '/'
      },
      setCount: false
    }
  },
  created () {
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
  },
  methods: {
    callPrev () {
      if (this.setCount) {
        this.$router.push('/')
      } else {
        history.go(1)
      }
      this.setCount = true
      // 클로즈 함수 구현
    }
  },
  components: {
    AppHeader,
    AppSidebar
  },
  beforeDestroy () {
    this.setCount = false
  }
}
</script>

<style lang="scss" scoped>
</style>
